module.exports = __webpack_public_path__ + "OYN-logo-2016_copy_317757b7-57e2-47bc-8bf0-66ccdab347ee.jpg?ea4081c2870c026934b89ab813a92b07";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/OYN-logo-2016_copy_317757b7-57e2-47bc-8bf0-66ccdab347ee.jpg
// module id = 100
// module chunks = 0